import { EventEmitter } from '@angular/core';
import { isNullOrUndefined } from '../../../extensions/object/object.detect.extensions';
import { ListColumnHeaderSortEvent } from './events/sort.event';
var ListColumnHeaderComponent = /** @class */ (function () {
    function ListColumnHeaderComponent() {
        this.sortable = false;
        this.onSort = new EventEmitter();
    }
    Object.defineProperty(ListColumnHeaderComponent.prototype, "isSortedOnce", {
        get: function () {
            return !isNullOrUndefined(this.isAsc);
        },
        enumerable: true,
        configurable: true
    });
    ListColumnHeaderComponent.prototype.sort = function () {
        if (this.sortable) {
            if (!this.isSortedOnce) {
                this.isAsc = true;
            }
            else {
                this.isAsc = !this.isAsc;
            }
            this.onSort.emit(new ListColumnHeaderSortEvent(this, this.isAsc));
        }
    };
    ListColumnHeaderComponent.prototype.clearSortStatus = function () {
        this.isAsc = null;
    };
    return ListColumnHeaderComponent;
}());
export { ListColumnHeaderComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/column.header/list.column.header.component.ts.pre-build-optimizer.js